import { ToastContainer, toast } from 'react-toastify';

import loading from "../../assets/images/loading.gif"
import { useState, useEffect } from "react";
import { makeGetRequest, makePatchRequest, makePostRequest } from "../../request";
import Layout from '../Layout';
import { customStyles } from 'helpers';
import Modal from 'react-modal'
// import { useLocation, useNavigate } from 'react-router-dom';

const FinalShippingAddressMapping =  () => {
    // VARIABLE DEFINITIONS
    // const location = useLocation()
    // const navigate = useNavigate()

    const [finalShippingAddresses, setRecords] = useState<Record<string, any>[]>([])
    const [searchValue, setSearchValue] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isOpenCreateModal, setIsOpenCreateModal] = useState(false)
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)
    const [formData, setFormData] = useState<Record<string, any>>({
        consignee: "",
        consigneeCode: "",
        plantCode: "",
        plantDescription: "",
        destinationPlantOrSiteOrProject: "",
    })
    const [errorData, setErrorData] = useState<Record<string, any>>({
        consignee: "",
        consigneeCode: "",
        plantCode: "",
        plantDescription: "",
        destinationPlantOrSiteOrProject: "",
    })

    const handleClearFormData = () => {
        setFormData({
            consignee: "",
            consigneeCode: "",
            plantCode: "",
            plantDescription: "",
            destinationPlantOrSiteOrProject: "",
        })
    }
    // const [currentPage, setCurrentPage] = useState(statusBeforeNavigation?.page ? statusBeforeNavigation.page : 1);
    // const [itemsPerPage, setItemsPerPage] = useState(10);
    // const [totalItems, setTotalItems] = useState(0);      
    

    // // FUNCTIONS
    // const totalPages = Math.ceil(totalItems / itemsPerPage);
    // const [startIndex, setStartIndex] = useState(0);
    // const getPageNumbers = () => {
    //     return Array.from({ length: totalPages }, (_, i) => i + 1);
    // };

    // const handleNext = () => {
    //     if (currentPage < totalPages) {
    //         setCurrentPage(currentPage + 1);
    //         if (currentPage >= startIndex + 4) {
    //             setStartIndex(startIndex + 4);
    //         }
    //     }
    // };

    // const handlePrevious = () => {
    //     if (currentPage > 1) {
    //         setCurrentPage(currentPage - 1);
    //         if (currentPage - 1 <= startIndex) {
    //             setStartIndex(startIndex - 4);
    //         }
    //     }
    // };
    
    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) {setSearchValue("");}
    }

    // const [status, setStatus] = useState<number | null>(statusBeforeNavigation?.status ? statusBeforeNavigation.status : 1)
    const getSAPFinalShippingAddressMapper = () => {
            setIsLoading(true)
            var request: Record<string, any> = {
                what: "getSAPFinalShippingAddressMapper",
            };
            if(searchValue) {request.params.SearchString = searchValue;}
            
            makeGetRequest(request)
                .then((response: any) => {
                    setIsLoading(false)
                    const res = response.data.data
                    setRecords(res)
                })
                .catch((error:any) => 
                    toast.error(error.errorMessage)
                );
    }    

    const handleChange = (event: any) => {        
        const { name, value } = event.target //get data form each input on change
        //if(name === "consignee") setFormData(values => ({...formData, consigneeCode: formData.consignee === "TEPNG" ? "NG01" : "NG02"}))
        setFormData(values => ({...formData, [name]: value})) //set retrieved values to "formData" object 
    }

    const handleCreateSAPFinalShippingAddressMapping = () => {
        if(!formData.plantCode) setErrorData({ ...errorData, plantCode: 'This field is required!' });
        else setErrorData({ ...errorData, plantCode: '' });

        if(!formData.plantDescription) setErrorData({ ...errorData, plantDescription: 'This field is required!' });
        else setErrorData({ ...errorData, plantDescription: '' });

        if(!formData.destinationPlantOrSiteOrProject) setErrorData({ ...errorData, destinationPlantOrSiteOrProject: 'This field is required!' });
        else setErrorData({ ...errorData, destinationPlantOrSiteOrProject: '' });

        if(!formData.consignee) setErrorData({ ...errorData, consignee: 'This field is required!' });
        else setErrorData({ ...errorData, consignee: '' });

        var data = formData
        data.consigneeCode = formData.consignee === "TEPNG" ? "NG01" : "NG02"
        if (Object.values(data).every(value => value)){
            setIsSubmitting(true)
            var request:Record<string, any> = {
                what: "CreateSAPFinalShippingAddressMapping",
                data: data
            };             
            makePostRequest(request)
                .then((response: any) => {  
                    setIsSubmitting(false)
                    toast.success(response.msg)
                    setIsOpenCreateModal(false)
                    getSAPFinalShippingAddressMapper()
                    handleClearFormData()
                })
                .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
        }else {
            toast.warning("Please provide information for all required fields")
        }
    }

    const handleUpdateSAPFinalShippingAddressMapping = () => {
        if(!formData.plantCode) setErrorData({ ...errorData, plantCode: 'This field is required!' });
        else setErrorData({ ...errorData, plantCode: '' });

        if(!formData.plantDescription) setErrorData({ ...errorData, plantDescription: 'This field is required!' });
        else setErrorData({ ...errorData, plantDescription: '' });

        if(!formData.destinationPlantOrSiteOrProject) setErrorData({ ...errorData, destinationPlantOrSiteOrProject: 'This field is required!' });
        else setErrorData({ ...errorData, destinationPlantOrSiteOrProject: '' });

        if(!formData.consignee) setErrorData({ ...errorData, consignee: 'This field is required!' });
        else setErrorData({ ...errorData, consignee: '' });

        var data = formData
        data.consigneeCode = formData.consignee === "TEPNG" ? "NG01" : "NG02"
        if (Object.values(data).every(value => value)){
            setIsSubmitting(true)
            var request:Record<string, any> = {
                what: "UpdateSAPFinalShippingAddressMapping",
                data: data
            };             
            makePatchRequest(request)
                .then((response: any) => {  
                    setIsSubmitting(false)
                    toast.success(response.msg)
                    setIsOpenCreateModal(false)
                    getSAPFinalShippingAddressMapper()
                    handleClearFormData()
                })
                .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
        }else {
            toast.warning("Please provide information for all required fields")
        }
    }
    // LIST POCS
    const row = finalShippingAddresses
                ?.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime())
                .map((data, index) => {
                    return (
                        <tr key={index}>
                            {/* <td>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td> */}
                            <td>{ index + 1 }</td>
                            <td>{ data.plantCode }</td>
                            <td>{ data.plantDescription }</td>
                            <td>{ data.consigneeCode }</td>
                            <td>{ data.consignee }</td>
                            <td>{ data.destinationPlantOrSiteOrProject }</td>
                            <td>
                                <button 
                                onClick={() => {setIsOpenEditModal(true); setFormData(data)}} 
                                className="custom-button orange-outline">
                                    Update
                                </button>
                            </td>
                        </tr>
                    )
                })

    useEffect(() => {
        getSAPFinalShippingAddressMapper()// eslint-disable-next-line
    }, [searchValue])

    const page = "Shipping Address Mapper";

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search..." onKeyUp={handleSearch}  />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => setSearchValue((document.getElementById("search") as HTMLInputElement)?.value)}
                                >Search</button>
                            </div>
                            <div className="d-flex page-filter" onClick={() => {setIsOpenCreateModal(true); handleClearFormData()}}>
                                <button className='custom-button orange'>
                                    Add New Mapping
                                </button>
                            </div>
                        </div>                        

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th>SN</th>
                                        <th>Plant Code</th>
                                        <th>Plant Description</th>
                                        <th>Consignee Code</th>
                                        <th>Consignee</th>
                                        <th>Desination Site/Project</th>
                                        <th style={{width: "110px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            finalShippingAddresses?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        {/* <div className="pagination-container" hidden={true}>
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                                startIndex={startIndex} />
                        </div> */}
                    </div>                 
                </div>
                <ToastContainer />
                <Modal isOpen={isOpenCreateModal} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Add New Final Shipping Address Mapping</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => setIsOpenCreateModal(false)}>close</span>
                    </div>
                    <div className="modal-body" style={{maxHeight: "400px", overflowY: "auto"}}>
                        <div className="d-flex gap-3">
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Plant Code</label>
                                <input 
                                    name="plantCode" 
                                    value={formData.plantCode} 
                                    onChange={handleChange} /> 
                                <p className="error">{ errorData.plantCode }</p>
                            </div>
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Plant Description</label>
                                <input 
                                    name="plantDescription" 
                                    value={formData.plantDescription} 
                                    onChange={handleChange} />  
                                <p className="error">{ errorData.plantDescription }</p>
                            </div>                            
                        </div> 

                        <div className="d-flex gap-3">
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Consignee</label>
                                <select 
                                name='consignee' 
                                value={formData.consignee} 
                                onChange={handleChange}>
                                    <option value="" key="0" disabled>Select Consignee</option>
                                    <option value="TEPNG" key="1">TEPNG</option>
                                    <option value="TUPNI" key="2">TUPNI</option>
                                </select>
                                <p className="error">{ errorData.consignee }</p>
                            </div>
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Consignee Code</label>
                                <input 
                                    disabled
                                    name="consigneeCode" 
                                    value={formData.consignee === "TEPNG" ? "NG01" : formData.consignee === "TUPNI" ? "NG02" : ""} />  
                                <p className="error">{ errorData.consigneeCode }</p>
                            </div>                            
                        </div>                    
                        
                        <label><span className="errorX mr-2">*</span>Destination Plant/Site</label>
                        <select 
                            name='destinationPlantOrSiteOrProject' 
                            value={formData.destinationPlantOrSiteOrProject} onChange={handleChange}>
                                <option value="" key="0" disabled>Select Destination Plant/Site</option>
                                {
                                    Array.from(new Set(finalShippingAddresses?.map((item: any) => item.destinationPlantOrSiteOrProject)))
                                    ?.sort((a: any, b: any) => a.localeCompare(b))
                                    ?.map((item: any, index: number) => (
                                        <option value={item} key={index}>{item}</option>
                                    ))
                                }
                        </select>
                        <p className="error">{ errorData.destinationPlantOrSiteOrProject }</p>
                    </div>
                    <div className="modal-footer bt-1">
                        <button className="custom-button grey-outline"
                            onClick={() => setIsOpenCreateModal(false)}>Cancel</button>
                        <button disabled={isSubmitting} type="submit" className="custom-button orange"
                            onClick={() => handleCreateSAPFinalShippingAddressMapping()}>{isSubmitting ? "Loading..." : "Submit"}</button>
                    </div>
                </Modal>

                <Modal isOpen={isOpenEditModal} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Update Final Shipping Address Mapping</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => setIsOpenEditModal(false)}>close</span>
                    </div>
                    <div className="modal-body" style={{maxHeight: "400px", overflowY: "auto"}}>
                        <div className="d-flex gap-3">
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Plant Code</label>
                                <input 
                                    name="plantCode" 
                                    value={formData.plantCode} 
                                    onChange={handleChange} /> 
                                <p className="error">{ errorData.plantCode }</p>
                            </div>
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Plant Description</label>
                                <input 
                                    name="plantDescription" 
                                    value={formData.plantDescription} 
                                    onChange={handleChange} />  
                                <p className="error">{ errorData.plantDescription }</p>
                            </div>                            
                        </div> 

                        <div className="d-flex gap-3">
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Consignee</label>
                                <select 
                                name='consignee' 
                                value={formData.consignee} 
                                onChange={handleChange}>
                                    <option value="" key="0" disabled>Select Consignee</option>
                                    <option value="TEPNG" key="1">TEPNG</option>
                                    <option value="TUPNI" key="2">TUPNI</option>
                                </select>
                                <p className="error">{ errorData.consignee }</p>
                            </div>
                            <div className='w-100'>
                                <label><span className="errorX mr-2">*</span>Consignee Code</label>
                                <input 
                                    disabled
                                    name="consigneeCode" 
                                    value={formData.consignee === "TEPNG" ? "NG01" : formData.consignee === "TUPNI" ? "NG02" : ""} />  
                                <p className="error">{ errorData.consigneeCode }</p>
                            </div>                            
                        </div>                    
                        
                        <label><span className="errorX mr-2">*</span>Destination Plant/Site</label>
                        <select 
                            name='destinationPlantOrSiteOrProject' 
                            value={formData.destinationPlantOrSiteOrProject} onChange={handleChange}>
                                <option value="" key="0" disabled>Select Destination Plant/Site</option>
                                {
                                    Array.from(new Set(finalShippingAddresses?.map((item: any) => item.destinationPlantOrSiteOrProject)))
                                    ?.sort((a: any, b: any) => a.localeCompare(b))
                                    ?.map((item: any, index: number) => (
                                        <option value={item} key={index}>{item}</option>
                                    ))
                                }
                        </select>
                        <p className="error">{ errorData.destinationPlantOrSiteOrProject }</p>
                    </div>
                    <div className="modal-footer bt-1">
                        <button className="custom-button grey-outline"
                            onClick={() => setIsOpenEditModal(false)}>Cancel</button>
                        <button disabled={isSubmitting} type="submit" className="custom-button orange"
                            onClick={() => handleUpdateSAPFinalShippingAddressMapping()}>{isSubmitting ? "Loading..." : "Update"}</button>
                    </div>
                </Modal>
            </div>
        </Layout>
    )
}

export default FinalShippingAddressMapping